import React from 'react';
import { type WrappedComponentProps, injectIntl } from 'react-intl-next';
import type { ExtensibleTabProps } from '../extensible-tab-types';
import { CROSS_PRODUCT_PRODUCT_ID } from './suppliers';
import { messages } from './messages';
import {
	PostQuerySupplierArgs,
	PreQuerySupplierArgs,
	SearchDialogProduct,
	SearchItems,
} from '../../product-router';
import { getSections } from './sections';
import { CrossProductScope } from './types';

export type CrossProductTabProps = ExtensibleTabProps;

const CrossProductTabWithIntl = ({
	intl,
	...rest
}: WrappedComponentProps & CrossProductTabProps) => {
	return (
		<SearchDialogProduct
			preQueryItemSupplier={function (args: PreQuerySupplierArgs): Promise<SearchItems<{}>> {
				throw new Error('Function not implemented.');
			}}
			postQueryItemSupplier={function (args: PostQuerySupplierArgs): Promise<SearchItems<{}>> {
				throw new Error('Function not implemented.');
			}}
			sections={getSections(intl)}
			id={CROSS_PRODUCT_PRODUCT_ID}
			title={intl.formatMessage(messages.cross_product_tab_label)}
			expandedStateInputPlaceholder={intl.formatMessage(
				messages.cross_product_expanded_input_placeholder,
			)}
			permissionSupplier={() => Promise.resolve(Object.values(CrossProductScope))}
			{...rest}
		>
			{() => {
				return {
					Footer: () => <></>,
				};
			}}
		</SearchDialogProduct>
	);
};

export const CrossProductTab = injectIntl(CrossProductTabWithIntl);
